<template>
    <BannerAbstract class="banner-survey" person="jonas">

        <template #title>
            Hey,
        </template>
        <template #message>
            <i>I’m Jonas</i> from GENERIO. I would love to know what you think
            about our platform and how we can better <i>support you.</i>
        </template>
        <template #actions>
            <slot></slot>
        </template>

    </BannerAbstract>
</template>

<script>
import BannerAbstract from '@/components/common/banner/BannerAbstract.vue'

export default {
    name: 'BannerSurvey',
    components: {
        BannerAbstract
    }
}
</script>

<style>
.banner-survey .v-btn {
    background-color: rgb(var(--v-theme-darkbase));
    border: 2px solid rgb(var(--v-theme-darkerbase));
}

.banner-survey .v-btn:hover {
    background-color: rgba(var(--v-theme-color1), 0.5);
}
</style>